var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        "close-on-click-modal": false,
        title: _vm.$t("fixDutyFine.finalDetermination"),
        visible: _vm.visible,
        width: "620px",
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c("div", { staticClass: "penalty-dialog-content" }, [
        _c(
          "div",
          { staticClass: "info-block" },
          [
            _c(
              "el-row",
              { attrs: { gutter: 20 } },
              [
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(_vm._s(_vm.$t("fixDutyFine.selected"))),
                    ]),
                    _c("span", { staticClass: "info-value text-bold" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.count) +
                          " " +
                          _vm._s(_vm.$t("fixDutyFine.ticketsUnit")) +
                          " "
                      ),
                    ]),
                  ]),
                ]),
                _c("el-col", { attrs: { span: 12 } }, [
                  _c("div", { staticClass: "info-item" }, [
                    _c("span", { staticClass: "info-label" }, [
                      _vm._v(_vm._s(_vm.$t("base.billingMonth"))),
                    ]),
                    _c("span", { staticClass: "info-value" }, [
                      _vm._v(_vm._s(_vm.month || "--")),
                    ]),
                  ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "radio-group-block" },
          [
            _c(
              "el-radio-group",
              {
                staticClass: "custom-radio-group",
                model: {
                  value: _vm.reviewType,
                  callback: function ($$v) {
                    _vm.reviewType = $$v
                  },
                  expression: "reviewType",
                },
              },
              [
                _c(
                  "el-radio",
                  { staticClass: "custom-radio", attrs: { label: 3 } },
                  [
                    _c("span", { staticClass: "radio-text" }, [
                      _vm._v(_vm._s(_vm.$t("fixDutyFine.exempt"))),
                    ]),
                  ]
                ),
                _c(
                  "el-radio",
                  { staticClass: "custom-radio", attrs: { label: 4 } },
                  [
                    _c("span", { staticClass: "radio-text" }, [
                      _vm._v(_vm._s(_vm.$t("fixDutyFine.maintainOriginal"))),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "textarea-block" },
          [
            _c("div", { staticClass: "required-label" }, [
              _vm._v(_vm._s(_vm.$t("fixDutyFine.reviewOpinion"))),
            ]),
            _c("el-input", {
              attrs: {
                placeholder:
                  _vm.reviewType === 4
                    ? _vm.$t("fixDutyFine.maintainOpinionPlaceholder")
                    : _vm.$t("fixDutyFine.reviewOpinionPlaceholder"),
                rows: 4,
                maxlength: "500",
                "show-word-limit": "",
                type: "textarea",
              },
              model: {
                value: _vm.reviewOpinion,
                callback: function ($$v) {
                  _vm.reviewOpinion = $$v
                },
                expression: "reviewOpinion",
              },
            }),
          ],
          1
        ),
      ]),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [
            _vm._v(_vm._s(_vm.$t("fixDutyFine.cancel"))),
          ]),
          _c(
            "el-button",
            {
              attrs: { loading: _vm.submitting, type: "success" },
              on: { click: _vm.handleSubmit },
            },
            [_vm._v(_vm._s(_vm.$t("fixDutyFine.confirmDetermination")) + " ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }